import * as Yup from "yup";
import { Maybe, WeatherCondition } from "../../generated/graphql";
import { getInitialValues } from "../../services/config";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
        abbreviation: Yup.string().required().default("")
    })
}

export default function surveyRecordVerificationClassificationFormInit(record?: Maybe<WeatherCondition>) {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}
